import { LoggingModule } from 'services/Logger';

export default {
  MODAL_TEXT: {
    title: 'User Ineligible',
    slug: (name: string) => {
      const firstLine = name ? `We noticed you are viewing as ${name}. ` : '';
      return `${firstLine}Connect Care can only be used for yourself or a minor.`;
    },
    severity: 'warning',
    copy:
      'If you are trying to use Connect Care for an adult other than yourself, you would need to log into their MyHealth+ account or use the standalone Connect Care app with their credentials.',
    confirm: 'Switch to my profile',
    decline: 'Exit Connect Care'
  },
  ERROR: {
    title: 'Unable to switch accounts',
    severity: 'error',
    text: 'Ok',
    description:
      'Sorry, we ran into a problem switching to your profile. Please try again through the profile screen.',
    LOGGER: {
      title: `${LoggingModule.switchAccount}Failed to switch account`,
      consumerNotFound: 'Could not find consumerId'
    }
  },
  SUCCESS: {
    LOGGER: {
      source: 'Connect Care Proxy Warning'
    }
  }
};
